export default{
    section:'بخش',
    cardiacActivitiesTitle: 'Title',
    sectionStatus: 'Status',
    cardiacActivities:'Cardiac Activities',
    editCardiacActivities:'Edit Cardiac Activities',
    addCardiacActivities:'New Cardiac Activities ',
}